<h2 app-landing-page-title i18n="@@landingPage.firearms.title">Firearms</h2>

<mat-card>
  <mat-card-header>
    <mat-card-title>
      <persistent-simple-text-section-entity section="landingPage.firearms.title">
      </persistent-simple-text-section-entity>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-firearm-assignment-pending-action-list *ngIf="showPendingAssignments()" [queryParams]="queryParams" [onInitSearchDelay]="true"></app-firearm-assignment-pending-action-list>
    <persistent-rich-text-section-entity section="landingPage.firearms.text"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>